<tidy-wrapper>
  <div class="preview-loading">
    <tidy-text [body]="'Setting up preview…'" />
  </div>
</tidy-wrapper>
